import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Navbar = ({ userRole }) => {
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const getNavLinkIcon = (path) => {
    const icons = {
      '/admin/routes': '🛣️',
      '/user/routes': '🛣️',
      '/admin/users': '👥',
      '/admin/payments': '💰',
      '/admin/transactions': '📊',
      '/admin/destinations': '🗺️',
      '/user/payments': '📊'
    };
    return icons[path] || '📄';
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand-container">
          <Link 
            to={(userRole || user?.role) === 'admin' ? '/admin' : '/user'} 
            className="navbar-brand-link"
            onClick={closeMenu}
          >
            <div className="navbar-logo-container">
              <img src="/logo.svg" alt="Logo" className="navbar-logo" />
              <div className="navbar-brand">
                <span className="brand-full">Transport CRM</span>
                <span className="brand-short">CRM</span>
              </div>
            </div>
          </Link>
          <button 
            className="mobile-menu-toggle" 
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <span className="menu-icon">{isMenuOpen ? '✕' : '☰'}</span>
          </button>
        </div>
        <div className={`navbar-menu ${isMenuOpen ? 'open' : ''}`}>
          <ul className="navbar-nav">
            {userRole === 'admin' ? (
              <>
                <li>
                  <Link to="/admin/routes" onClick={closeMenu} className="nav-link">
                    <span className="nav-icon">{getNavLinkIcon('/admin/routes')}</span>
                    <span className="nav-text">Rutas</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/users" onClick={closeMenu} className="nav-link">
                    <span className="nav-icon">{getNavLinkIcon('/admin/users')}</span>
                    <span className="nav-text">Usuarios</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/payments" onClick={closeMenu} className="nav-link">
                    <span className="nav-icon">{getNavLinkIcon('/admin/payments')}</span>
                    <span className="nav-text">A Pagar</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/transactions" onClick={closeMenu} className="nav-link">
                    <span className="nav-icon">{getNavLinkIcon('/admin/transactions')}</span>
                    <span className="nav-text">Transacciones</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/destinations" onClick={closeMenu} className="nav-link">
                    <span className="nav-icon">{getNavLinkIcon('/admin/destinations')}</span>
                    <span className="nav-text">Destinos</span>
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/user/routes" onClick={closeMenu} className="nav-link">
                    <span className="nav-icon">{getNavLinkIcon('/user/routes')}</span>
                    <span className="nav-text">Mis Rutas</span>
                  </Link>
                </li>
                <li>
                  <Link to="/user/payments" onClick={closeMenu} className="nav-link">
                    <span className="nav-icon">{getNavLinkIcon('/user/payments')}</span>
                    <span className="nav-text">Transacciones</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
          <div className="navbar-actions">
            <div className="user-info">
              <span className="user-icon">👤</span>
              <div className="user-details">
                <span className="user-name">{user?.name}</span>
                <span className="user-role">{user?.role === 'admin' ? 'Administrador' : 'Usuario'}</span>
              </div>
            </div>
            <button className="btn-logout" onClick={handleLogout}>
              <span className="logout-icon">🚪</span>
              <span className="logout-text">Cerrar Sesión</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
